import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {CreateUpdateDefaultPagePageModule} from '../../../../../../core/page/create-update-default-page/create-update-default-page.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {CardModule} from '../../../../../../core/component/card/card.module';
import {PartnerSearchModule} from '../../../../../../partner/common/api/component/partner-search/partner-search.module';
import {LovValueSelectFilterModule} from '../../../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module';
import {LabelRequiredModule} from '../../../../../../../shared/directives/label-required.module';
import {FormFieldModule} from '../../../../../../core/component/form-field/form-field.module';
import {SelectFilterModule} from '../../../../../../../components/common/select-filter/select-filter.module';
import {LovValuesSelectFilterModule} from '../../../../../../common/lov/lov-value/api/component/lov-values-select-filter/lov-values-select-filter.module';
import {MatSliderModule} from '@angular/material/slider';
import {FormArrayInputModule} from '../../../../../../../components/common/form-array/form-array-input/form-array-input.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {DatePickerModule} from '../../../../../../../components/common/date-picker/date-picker.module';
import {CustomDateInputModule} from '../../../../../../../components/common/date/custom-date/custom-date-input/custom-date-input.module';
import {MedicalRecordPainCreateUpdateComponent} from './medical-record-pain-create-update.component';
import {CreateUpdateDefaultModule} from '../../../../../../core/component/create-update-default/create-update-default.module';
import {RichTextEditorModule} from '../../../../../../../components/common/rich-text-editor/rich-text-editor.module';
import {DialogModule} from '../../../../../../common/dialog/dialog.module';
import {LoadingModule} from '../../../../../../../components/common/loading/loading.module';
import {ButtonModule} from '../../../../../../core/component/button/button.module';
import {
    CheckboxInputModule
} from '../../../../../../../components/common/checkbox/checkbox-input/checkbox-input.module';
import {
    LovValuesChipsAutocompleteModule
} from '../../../../../../common/lov/lov-value/api/component/lov-value-chips-autocomplete/lov-values-chips-autocomplete.module';
import {
    DateSummaryFieldModule
} from "../../../../../../core/component/date/date-summary-field/date-summary-field.module";
import {SummaryFieldModule} from "../../../../../../core/component/summary-field/summary-field.module";
import {ItemModule} from "../../../../../../core/component/item/item.module";
import {SummaryModule} from "../../../../../../core/component/summary/summary.module";
import {CardV2Component} from "../../../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CardModule,
        ReactiveFormsModule,
        CreateUpdateDefaultPagePageModule,
        MatCheckboxModule,
        PartnerSearchModule,
        LovValueSelectFilterModule,
        LabelRequiredModule,
        FormFieldModule,
        SelectFilterModule,
        LovValuesSelectFilterModule,
        MatSliderModule,
        FormArrayInputModule,
        MatFormFieldModule,
        DatePickerModule,
        CustomDateInputModule,
        CreateUpdateDefaultModule,
        LovValuesSelectFilterModule,
        LovValuesChipsAutocompleteModule,
        RichTextEditorModule,
        DialogModule,
        LoadingModule,
        ButtonModule,
        CheckboxInputModule,
        DateSummaryFieldModule,
        SummaryFieldModule,
        ItemModule,
        SummaryModule,
        CardV2Component,
    ],
    declarations: [MedicalRecordPainCreateUpdateComponent],
    exports: [
        MedicalRecordPainCreateUpdateComponent
    ]
})
export class MedicalRecordPainCreateUpdateModule {
}
